/// <amd-module name="Repos/Tfvc/Views/ChangesetDetails/Components/ChangesetDetails" />
import * as React from "react";
import { getTfvcRoutingService } from "Repos/Tfvc/Common/TfvcRoutingService";
import { getTfvcFilesService } from "Repos/Tfvc/Files/TfvcFilesService";
import { getTfvcNavigationService } from "Repos/ChangesCommon/ChangesNavigationService";
import { ChangeDetailsContext, IChangeDetailsContext } from "Repos/Tfvc/Views/ChangeDetails/ChangeDetailsContext";
import { ChangeDetails } from "Repos/Tfvc/Views/ChangeDetails/Components/ChangeDetails";
import * as Resources from "Repos/Tfvc/Views/ChangesetDetails/Resources";
import { format } from "VSS/Core/Util/String";
import { onClickFPS } from "VSS/Platform/FPS";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { getRouteValues } from "VSS/Platform/Navigation";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";
import { getChangesetViewService, IChangesetDetailsViewService } from "../ChangesetDetailsViewService";
import { getDiscussionIntegrationService } from "../ChangesetDiscussionIntegrationService";

const ChangesetDetails = (): JSX.Element => {
    const { pageContext } = useComponentContext();
    let viewService: IChangesetDetailsViewService;

    try {
        viewService = getChangesetViewService(pageContext);
    } catch (ex) {
        // Changeset details data does not exist.
        const actionHref = getTfvcRoutingService(pageContext).getChangesetsHubUrl();
        const changesetId = getRouteValues(pageContext)["parameters"] || "";
        return (
            <ZeroData
                actionType={ZeroDataActionType.link}
                actionText={Resources.ChangesetNotFoundAction}
                actionHref={actionHref}
                className="flex-grow"
                imagePath={getAssetLocation(pageContext, "ms.vss-code-web/tfvc-common-content/Content/invalid-path.svg")}
                imageAltText={Resources.ChangesetNotFoundPrimary}
                onActionClick={e => onClickFPS(pageContext, actionHref, true, e)}
                primaryText={Resources.ChangesetNotFoundPrimary}
                secondaryText={format(Resources.ChangesetNotFoundSecondary, changesetId)}
            />
        );
    }

    const discussionService = getDiscussionIntegrationService(pageContext);
    const filesService = getTfvcFilesService(pageContext);
    const navigationService = getTfvcNavigationService(pageContext);
    const changeDetailsContext: IChangeDetailsContext = {
        discussionService,
        extensionContext: {
            childComponentProperties: {
                changesetId: viewService.getChangesetId()
            },
            componentRegion: "changesetDetailsExtensions",
            dependencies: ["ms.vss-code-web.changeset-details-extensions"]
        },
        filesService,
        getFileUrl: path => getTfvcRoutingService(pageContext).getChangesetDetailsUrl(viewService.getChangesetId(), undefined, path),
        navigationService,
        viewService,
        perfContext: {
            pendingWorkName: "changeset-render-tab",
            scenarioName: "changeset-details"
        }
    };

    return (
        <ChangeDetailsContext.Provider value={{ ...changeDetailsContext }}>
            <ChangeDetails />
        </ChangeDetailsContext.Provider>
    );
};

Components.add("ms.vss-code-web.tfvc-changeset-details", ChangesetDetails);
